var _defs, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSeigaiha(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "seigaiha_svg__b",
    patternUnits: "userSpaceOnUse",
    width: 230.4,
    height: 221.7,
    patternTransform: "scale(.5)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "seigaiha_svg__a",
    stroke: "#f8f7ff",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    strokeWidth: 8,
    r: 106.7
  }), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 9,
    r: 81
  }), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 8,
    r: 55.3
  }), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 7,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 7,
    r: 13.2
  }))), /*#__PURE__*/React.createElement("use", {
    x: 229.9,
    y: 0.7,
    xlinkHref: "#seigaiha_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 114.9,
    y: 55.3,
    xlinkHref: "#seigaiha_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    x: -114.9,
    y: 55.3,
    xlinkHref: "#seigaiha_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    y: 111.3,
    xlinkHref: "#seigaiha_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 229.9,
    y: 111.3,
    xlinkHref: "#seigaiha_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 114.9,
    y: 166.4,
    xlinkHref: "#seigaiha_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    x: -114.9,
    y: 166.4,
    xlinkHref: "#seigaiha_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    y: 222.2,
    xlinkHref: "#seigaiha_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 345.1,
    y: 166.4,
    xlinkHref: "#seigaiha_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 229.9,
    y: 222.2,
    xlinkHref: "#seigaiha_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 114.9,
    y: 277.2,
    xlinkHref: "#seigaiha_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    x: -114.9,
    y: 277.2,
    xlinkHref: "#seigaiha_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 345.1,
    y: 277.2,
    xlinkHref: "#seigaiha_svg__a"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#seigaiha_svg__b)"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIAp3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIj4KICA8ZGVmcz4KICAgIDxwYXR0ZXJuIGlkPSJ3YXZlcyIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgd2lkdGg9IjIzMC40IiBoZWlnaHQ9IjIyMS43IiBwYXR0ZXJuVHJhbnNmb3JtPSJzY2FsZSguNSkiPgogICAgICA8ZGVmcz4KICAgICAgICA8ZyBpZD0id2F2ZSIgc3Ryb2tlPSIjZjhmN2ZmIiBmaWxsPSJub25lIj4KICAgICAgICAgIDxjaXJjbGUgZmlsbD0iI0ZGRiIgc3Ryb2tlLXdpZHRoPSI4IiByPSIxMDYuNyIgLz4KICAgICAgICAgIDxjaXJjbGUgc3Ryb2tlLXdpZHRoPSI5IiByPSI4MSIgLz4KICAgICAgICAgIDxjaXJjbGUgc3Ryb2tlLXdpZHRoPSI4IiByPSI1NS4zIiAvPgogICAgICAgICAgPGNpcmNsZSBzdHJva2Utd2lkdGg9IjciIHI9IjMyLjUiIC8+CiAgICAgICAgICA8Y2lyY2xlIHN0cm9rZS13aWR0aD0iNyIgcj0iMTMuMiIgLz4KICAgICAgICA8L2c+CiAgICAgIDwvZGVmcz4KICAgICAgPHVzZSB4PSIyMjkuOSIgeT0iMC43IiB4bGluazpocmVmPSIjd2F2ZSIgLz4KICAgICAgPHVzZSB4PSIxMTQuOSIgeT0iNTUuMyIgeGxpbms6aHJlZj0iI3dhdmUiIC8+CiAgICAgIDx1c2UgeD0iLTExNC45IiB5PSI1NS4zIiB4bGluazpocmVmPSIjd2F2ZSIgLz4KICAgICAgPHVzZSB4PSIwIiB5PSIxMTEuMyIgeGxpbms6aHJlZj0iI3dhdmUiIC8+CiAgICAgIDx1c2UgeD0iMjI5LjkiIHk9IjExMS4zIiB4bGluazpocmVmPSIjd2F2ZSIgLz4KICAgICAgPHVzZSB4PSIxMTQuOSIgeT0iMTY2LjQiIHhsaW5rOmhyZWY9IiN3YXZlIiAvPgogICAgICA8dXNlIHg9Ii0xMTQuOSIgeT0iMTY2LjQiIHhsaW5rOmhyZWY9IiN3YXZlIiAvPgogICAgICA8dXNlIHg9IjAiIHk9IjIyMi4yIiB4bGluazpocmVmPSIjd2F2ZSIgLz4KICAgICAgPHVzZSB4PSIzNDUuMSIgeT0iMTY2LjQiIHhsaW5rOmhyZWY9IiN3YXZlIiAvPgogICAgICA8dXNlIHg9IjIyOS45IiB5PSIyMjIuMiIgeGxpbms6aHJlZj0iI3dhdmUiIC8+CiAgICAgIDx1c2UgeD0iMTE0LjkiIHk9IjI3Ny4yIiB4bGluazpocmVmPSIjd2F2ZSIgLz4KICAgICAgPHVzZSB4PSItMTE0LjkiIHk9IjI3Ny4yIiB4bGluazpocmVmPSIjd2F2ZSIgLz4KICAgICAgPHVzZSB4PSIzNDUuMSIgeT0iMjc3LjIiIHhsaW5rOmhyZWY9IiN3YXZlIiAvPgogICAgPC9wYXR0ZXJuPgogIDwvZGVmcz4KICA8cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI3dhdmVzKSIgLz4KPC9zdmc+";
export { SvgSeigaiha as ReactComponent };